import { Link } from "react-router-dom";
import Container from "../components/Container";
import SectionTitle from "../components/Home/SectionTitle";
import WeddingsTable from "../components/Home/WeddingsTable";
import { useSiteContent } from "../context/SiteContentContext";

export default function Weddings() {
  const { tables } = useSiteContent();

  return (
    <main className="pb-20">
      <section className="pb-8 pt-10">
        <Container>
          <div className="rounded-[32px] bg-[#f3eee5] px-6 py-10 text-right md:px-10 lg:flex lg:items-end lg:justify-between">
            <div className="max-w-3xl">
              <p className="text-sm font-bold text-[#8a7355]">
                {tables.weddingsPageEyebrow}
              </p>
              <SectionTitle
                title={tables.weddingsTabLabel}
                classes="mt-3 text-[#3e352b]"
              />
              <p className="mt-4 max-w-2xl text-[16px] leading-7 text-[#5d5348]">
                {tables.weddingsPageDescription}
              </p>
            </div>

            <Link
              to="/"
              className="mt-6 inline-flex rounded-full border border-[#8a7355] px-5 py-3 text-sm font-bold text-[#5d5348] transition-colors hover:bg-[#8a7355] hover:text-white lg:mt-0"
            >
              {tables.backHomeLabel}
            </Link>
          </div>
        </Container>
      </section>

      <section>
        <Container>
          <div className="rounded-[32px] border border-[#eadfce] bg-white p-4 shadow-[0_18px_60px_rgba(76,58,37,0.08)] md:p-6">
            <WeddingsTable />
          </div>
        </Container>
      </section>
    </main>
  );
}
